export default __webpack_public_path__ + "static/media/UTPL_Fiscal_2023.df404114.pdf";